import { Button, DatePicker, Form, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  buttonLabel,
  dateFormat,
  formConfig,
  placeHolders,
} from '../../../../constants';
import moment from 'moment';
import { getMedicalCommissions } from '../../../../appRedux/actions/Reports';
import { useEffect } from 'react';
import { CustomSelect } from '../../../uiComponents';
import { getSubsidiaries } from '../../../../appRedux/actions';

export const MedicalCommissionsByBranchReportFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values.dates)
      values.dates = values.dates.map((date) =>
        moment(date)?.format(dateFormat)
      );
    dispatch(getMedicalCommissions(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="dates">
            <RangePicker format={dateFormat} />
          </Form.Item>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ width: 200 }}
              options={subsidiaries?.map(({ id, name }) => ({
                label: name,
                value: id,
              }))}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
